import { render, staticRenderFns } from "./ResponseActionSetup.vue?vue&type=template&id=6d872fb2"
import script from "./ResponseActionSetup.vue?vue&type=script&lang=ts"
export * from "./ResponseActionSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports